module.exports = __webpack_public_path__ + "img/document_icon.5577e1de.svg";